import { createReducer, on } from '@ngrx/store';
import { setOrder, setRotationOrder } from './order-cement-action';
import { initialOrderState } from './order-cement-state';

const _orderReducer = createReducer(
  initialOrderState,
  on(setOrder, (state: any, action) => {
    return {
      ...state,
      orderData: action.data,
    };
  }),
  on(setRotationOrder, (state: any, action) => {
    return {
      ...state,
      rotationOrderData: action.data,
    };
  })
);

export function orderReducer(state: any, action: any) {
  return _orderReducer(state, action);
}
